<div class="data-table__content">
  <span appEllipsisTooltip="">
    <ng-content></ng-content>
  </span>
  <span *ngIf="sorted"
        class="dds-data-table__icon-sorting {{order === sortOrder.Asc ? 'icon-sorted-AZ-16' : 'icon-sorted-ZA-16'}}"></span>
</div>
